import { inject, Injector, NgZone, ApplicationRef, DOCUMENT } from '@angular/core';
import { ComponentLoaderFactory } from 'ngx-bootstrap/component-loader';
import { PositioningService } from 'ngx-bootstrap/positioning';

/**
 * Parche de compatibilidad ngx-bootstrap 11 <-> Angular 22.
 *
 * ngx-bootstrap 11 fue compilado contra Angular 16 y su factory JIT
 * (`ɵɵngDeclareFactory`) referencia `ComponentFactoryResolver`, que fue
 * ELIMINADO en Angular 22. Al enlazar en runtime (dev SSR / Vite optimizer),
 * ese token se resuelve como `undefined` y la factory resultante llama
 * `ɵɵinject(undefined)` → crash:
 * `TypeError: Cannot read properties of undefined (reading 'hasOwnProperty')`.
 *
 * Re-enlazamos la factory con dependencias válidas para Angular 22.
 * `ComponentFactoryResolver` era usado solo para instanciar contenedores
 * dinámicos de tooltip/dropdown en el navegador; se pasa `undefined` porque
 * el método `attach()` de ComponentLoader no depende de él en la práctica.
 */
(ComponentLoaderFactory as any).ɵfac = function ComponentLoaderFactory_Factory(
  __ngFactoryType__?: any
) {
  return new (__ngFactoryType__ || ComponentLoaderFactory)(
    undefined, // ComponentFactoryResolver — eliminado en Angular 22
    inject(NgZone),
    inject(Injector),
    inject(PositioningService),
    inject(ApplicationRef),
    inject(DOCUMENT)
  );
};

// La ɵprov ya fue creada por el static block de la librería apuntando a la
// factory rota; actualizamos la referencia para que el fallback
// `providedIn: 'root'` use la factory reparada.
(ComponentLoaderFactory as any).ɵprov.factory = (ComponentLoaderFactory as any).ɵfac;
